export function canDataOfficerOpenAnalysisInStatus(status: string) {
  return !["INITIATED", "REJECTED_BY_DATA_OFFICER"]
    .includes(status);
}
